function PreviousIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      aria-hidden="true"
      viewBox="0 0 24 24"
    >
      <path
        fill="#7A8086"
        d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      ></path>
    </svg>
  );
}

export default PreviousIcon;
